import React from 'react';
import { PropertyDataProps } from '../../utility/types';
import {
  PropertyDetailsViewSelect,
  ViewOptions,
} from './PropertyDetailsViewSelect';
import { formatPrice } from '../../shared/utils/formatters/propertyFormatters';
import { FavoriteButton } from '../common/FavoriteButton';
import { ShareProperty } from './ShareProperty';
import { AddPropertyToList } from '../common/AddPropertyToList';
import { getPrice, isPropertyActive } from '../../utility/utility_functions';

type PropertyDetailsHeaderProps = {
  propertyDetails: PropertyDataProps;
  avmEstimatedValue: number | undefined;
  activeView: ViewOptions;
  setActiveView: (view: ViewOptions) => void;
};

const buttonContainerStyling = 'h-10 grow';

export const PropertyDetailsHeader = ({
  propertyDetails,
  avmEstimatedValue,
  activeView,
  setActiveView,
}: PropertyDetailsHeaderProps) => {
  const price = getPrice(propertyDetails) ?? avmEstimatedValue;
  const statusTextColor = isPropertyActive(propertyDetails)
    ? 'text-lime-600'
    : 'text-red-400';

  return (
    <div className="flex justify-center xl:justify-between flex-wrap gap-4">
      <div className="flex gap-2 font-bold items-center flex-wrap justify-around gap-x-6 mb-4 sm:mb-0">
        <p
          className="font-extrabold text-xl min-w-0 max-w-32 break-words"
          style={{ maxWidth: '18rem' }}
        >
          {propertyDetails?.address?.full_address ?? 'Address not available'}
        </p>
        <p className="font-extrabold text-3xl">{formatPrice(price)}</p>
        <div className="flex gap-2 text-sm">
          <p>{propertyDetails.bedrooms ?? 'N/A'} beds</p>
          <p>{propertyDetails.bathrooms ?? 'N/A'} bath</p>
          <p>{propertyDetails.sqft ?? 'N/A'} sq ft</p>
        </div>
        <p className={`${statusTextColor} font-bold text-sm`}>
          STATUS: {propertyDetails.status?.toUpperCase() ?? 'Not Listed'}
        </p>
      </div>
      <div className="flex items-center gap-4 my-auto flex-wrap justify-center">
        <div className={buttonContainerStyling}>
          <PropertyDetailsViewSelect
            activeView={activeView}
            setActiveView={setActiveView}
          />
        </div>
        <div className={buttonContainerStyling}>
          <AddPropertyToList property={propertyDetails} />
        </div>
        <div className={buttonContainerStyling}>
          <FavoriteButton propertyId={propertyDetails.id} />
        </div>
        <div className={buttonContainerStyling}>
          <ShareProperty property={propertyDetails} />
        </div>
      </div>
    </div>
  );
};
